import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import Entete from "./dataset/Entete";
import SellPeriod from "./dataset/SellPeriod";
import Dropdown from "./dataset/Dropdown";
import { ThemeContext } from "./ThemeContext";
import orders_completed from "../assets/Images/orders_completed.webp";
import orders_confirmed from "../assets/Images/orders_confirmed.webp";
import orders_deleted from "../assets/Images/orders_deleted.webp";
import orders_found from "../assets/Images/orders_found.webp";
import API from "../Authentification/apiAdmin";
import ValidationCommande from "./ValidationCommande";
import { useLocation } from "react-router-dom";
// import "../../Styles/AdminDashbord/commandes.css";

const Commandes = () => {
    const { theme } = useContext(ThemeContext);
    const [stats, setStats] = useState({});
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState("");

    const [showPopUp, setShowPopUp] = useState(false);
    const closePopUp = () => setShowPopUp(false);
    const openPopUp = (order) => {
        setSelectedOrder(order);
        setShowPopUp(true);
    };

    const location = useLocation();
    const [highlightedId, setHighlightedId] = useState(
        location.state?.highlightOrderId || null
    );

    useEffect(() => {
        if (highlightedId) {
            const el = document.getElementById(`order-row-${highlightedId}`);
            el?.scrollIntoView({ behavior: "smooth", block: "center" });

            const timeout = setTimeout(() => setHighlightedId(null), 3000);
            return () => clearTimeout(timeout);
        }
    }, [highlightedId]);

    useEffect(() => {
        API.get("/admin/orders")
            .then((res) => {
                setStats(res.data.stats);
                setOrders(res.data.orders);
            })
            .catch((err) => console.error(err));
    }, []);

    return (
        <div className="commandes-page">
            <Entete title="Commandes" />

            {/* Premier content */}
            <div className="">
                <div className="row mt-3 g-2">
                    <div className="col-12 col-md-4">
                        <SellPeriod />
                    </div>

                    <div className="col-12 col-md offset-md-3">
                        <h5 className="texte_brut">
                            Commandes vues : {orders.length}/100
                        </h5>
                        <div className="row g-2">
                            <div className="col-12 col-sm-6 me-md-2">
                                <Dropdown dropdown_item_1={"Epicerie"} dropdown_item_2={"Droguerie"}
                                    dropdown_item_3={"Produits locaux"} dropdown_item_4={"Produits frais"}
                                    dropdown_item_5={"Divers"} dropdown_item_6={"Boissons"} dropdown_item_7={"Electroménager"} />
                            </div>
                            <div className="col-12 col-sm">
                                <Dropdown type="Trier par : Meilleurs ventes" dropdown_item_1={"Nom"} dropdown_item_2={"type"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Deuxième content */}

            <div className="row mt-3 g-2">
                <div
                    className="col-12 col-md-4 me-md-2 mb-3 mb-md-0 shadow-sm border border-1 p-2"
                    style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                >
                    <h5 className="taux_moyen">Taux moyen (en %)</h5>
                    <p className="p-0 mb-1 m-0 petit_titre">Vues des produits</p>
                    <div className="progress">
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${stats.product_views_rate || 0}%` }}
                        >
                            {stats.product_views_rate || 0}%
                        </div>
                    </div>
                    <p className="p-0 m-0 mb-1 petit_titre mt-2">
                        Taux d'abandon du panier
                    </p>
                    <div className="progress">
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${stats.cart_abandon_rate || 0}%` }}
                        >
                            {stats.cart_abandon_rate || 0}%
                        </div>
                    </div>
                </div>

                {/* Cartes statistiques */}
                {[
                    { img: orders_completed, label: "Commandes effectuées", value: stats.completed },
                    { img: orders_confirmed, label: "Commandes confirmées", value: stats.confirmed },
                    { img: orders_deleted, label: "Commandes supprimées", value: stats.deleted },
                    { img: orders_found, label: "Total commandes", value: stats.found },
                ].map((item, i) => (
                    <div
                        key={i}
                        className="col-6 col-md me-md-2 mb-3 mb-md-0 shadow-sm border border-1"
                        style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                    >
                        <div className="row mt-2">
                            <div className="col">
                                <img src={item.img} alt=" " className="stat-icon w-auto" style={{ height: "50px" }} />
                            </div>
                            <div className="col-3">
                                <FontAwesomeIcon icon={faEllipsisVertical} />
                            </div>
                        </div>
                        <div className="mt-2">
                            <h5 className="petit_titre">{item.label}</h5>
                            <h5 className="taux_moyen">{item.value || 0}</h5>
                        </div>
                    </div>
                ))}
            </div>

            {/* Troisième content */}
            <div className="mt-3">
                <div
                    className="shadow-sm border border-1 col"
                    style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
                >
                    <div className="table-responsive">
                        <table className="table table-striped mb-0">
                            <thead>
                                <tr>
                                    <th>#id</th>
                                    <th>Utilisateur</th>
                                    <th className="col-5">Produits commandés</th>
                                    <th>Reference</th>
                                    <th>Total</th>
                                    <th>Statut</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order) => (
                                    <tr key={order.id} id={`order-row-${order.id}`}
                                        className={order.id === highlightedId ? "order-row-highlight" : ""}>
                                        <th>{order.id}</th>
                                        <td className="texte_brut">
                                            <div>{order.user?.name || "Néant"}</div>
                                            <div
                                                className="text-muted"
                                                style={{ fontSize: "0.75em" }}
                                            >
                                                {order.user?.email || " "}
                                            </div>
                                            <div
                                                className="text-muted"
                                                style={{ fontSize: "0.75em" }}
                                            >
                                                {order?.delivery_phone || "Néant"}
                                            </div>

                                            <div
                                                className="text-muted"
                                                style={{ fontSize: "0.75em" }}
                                            >
                                                {order.delivery_address || "Néant"}
                                            </div>
                                        </td>
                                        <td className="texte_brut text-capitalize">
                                            {(() => {
                                                try {
                                                    const produits = Array.isArray(order.produits)
                                                        ? order.produits
                                                        : JSON.parse(order.produits || "[]");

                                                    return produits
                                                        .map(p => `${p.name ?? p.nom ?? "Produit inconnu"} (x${p.quantite ?? 1})`)
                                                        .join(", ");
                                                } catch (e) {
                                                    if (process.env.NODE_ENV !== "production") {
                                                        console.error("Erreur parsing produits:", e);
                                                    }
                                                    return "Aucun produit";
                                                }
                                            })()}

                                        </td>
                                        <td className="texte_brut">{order?.payment?.transaction_id}</td>
                                        <td className="texte_brut">{order.total} FCFA</td>
                                        <td className="texte_brut">{order.status}</td>
                                        <td>
                                            <button
                                                className={`petit_titre btn btn-sm ${order.status === "livree" || order.status === "remboursee"
                                                    ? "btn-secondary"
                                                    : "btn-outline-primary"
                                                    }`}
                                                onClick={() => openPopUp(order)}
                                                disabled={order.status === "livree" || order.status === "remboursee"}
                                            >
                                                Voir
                                            </button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {showPopUp && <ValidationCommande closePopUp={closePopUp} order={selectedOrder} />}
        </div>
    );
};

export default Commandes;